import { IconCircleCheck } from '@tabler/icons-react'

import Text from 'components/ui/text'
import { ButtonCTA } from 'components/ui/button-cta'
import { translate } from 'utils/translation'
import ModalDialog from 'components/ui/modal-dialog'

export const SuccessUpdatePaymentModal = () => {
  const handleReload = (e: React.MouseEvent) => {
    e.stopPropagation()
    window.location.reload()
  }

  return (
    <ModalDialog
      maxSize="tw-max-w-2xl"
      isOpen
      variant="center"
      title={translate('update_billing_info_success_heading')}
      titleClassName="tw-text-3xl tw-px-8"
      zIndex="tw-z-[100001]"
      icon={
        <IconCircleCheck className="tw-min-h-[48px] tw-min-w-12 tw-stroke-1 tw-text-orange-500" />
      }
      // @ts-ignore
      onClose={handleReload}
      content={
        <>
          <Text className="tw-m-0 tw-px-8 tw-text-center tw-text-lg tw-text-zinc-700">
            update_billing_info_success_subheading
          </Text>
          <ButtonCTA
            className="tw-mt-6 tw-h-[52px] tw-px-5 tw-py-3"
            textClassName="tw-text-lg tw-font-black"
            onClick={handleReload}
            size="lg"
          >
            {translate('done_button')}
          </ButtonCTA>
        </>
      }
    />
  )
}
